﻿[
  {
    "id": 78,
    "code": "c1",
    "title": "Surname and first name required",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "(a) on beginning to use the sheet – his surname and first name;'",
      "The GB enforcement agency the Driver and Vehicle Standards Agency (DVSA) publication 'Rules on Drivers' Hours and Tachographs' Revised 2009 – GV262 - 02, page30 confirms: 'the law does not stipulate which order the names are put – but your employer may have a policy on this.'",
      "Page 31 also confirms: 'It is not acceptable for written entries to extend outside the centrefield area if they might interfere with chart recordings. If, for example, the driver's name or a place name is so long it must be abbreviated in order to avoid any possible interference with the recordings, the full name should be noted on the reverse of the chart.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85 and Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 and Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 79,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the drivers' name is missing or not entered correctly. Logistics UK analysis will only accept abbreviated names under exceptional circumstances, where prior consent had been received by the employer. This is because abbreviations are only acceptable in GB and only if the name is so long it must be abbreviated to avoid interference with recordings.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 80,
    "code": "c2",
    "title": "Vehicle registration number omitted/incorrect/incomplete",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(c) the registration number of each vehicle to which he is assigned, both at the start of the first journey recorded on the sheet ....'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 81,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the vehicle registration is missing or not entered correctly. Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 82,
    "code": "c3",
    "title": "Place of start/end omitted/incorrect",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(b) the...place where use of the sheet begins and the ...place where such use ends'",
      "The GB enforcement agency the Driver and Vehicle Standards Agency (DVSA) publication 'Rules on Drivers' Hours and Tachographs' Revised 2009 – GV262 - 02, page30 confirms: 'If the start and finish places are the same, both must be written on the chart – ditto marks are not acceptable' Page 31 also confirms: 'It is not acceptable for written entries to extend outside the centrefield area if they might interfere with chart recordings. If, for example, the driver's name or a place name is so long it must be abbreviated in order to avoid any possible interference with the recordings, the full name should be noted on the reverse of the chart.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport "
    ],
    "penalties": [
      {
        "id": 83,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the start or end location is missing or not entered correctly. Logistics UK analysis will only accept abbreviated places under exceptional circumstances, where it is clear that the name so long it must be abbreviated to avoid interference with recordings. Post codes are not acceptable.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 84,
    "code": "c4",
    "title": "Date of start/end omitted/incorrect",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(b) the date ... where use of the sheet begins and the date... where such use ends'",
      "DVSA publication 'Rules on Drivers' Hours and Tachographs' Revised 2009 – GV262 - 02, page30 confirms: 'The year may be written in full or abbreviated – so both '2007' and '07' are acceptable'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 85,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the start or end date is missing or not entered correctly.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate..",
        "extra": null
      }
    ]
  },
  {
    "id": 86,
    "code": "c5",
    "title": "Odometer readings omitted/incorrect/incomplete",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(d) the odometer reading:",
      "-\tat the start of the first journey recorded on the sheet,",
      "-\tat the end of the last journey recorded on the sheet,'",
      "DVSA publication 'Rules on Drivers' Hours and Tachographs' Revised 2009 – GV262 - 02, page30 confirms: 'Note that the 'total kms' field does not have to be completed.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 87,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 88,
    "code": "c6",
    "title": "Vehicle change details omitted",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(c) the registration number of each vehicle to which he is assigned, both at the start of the first journey recorded on the sheet and then, in the event of a change of vehicle, during use of the sheet;",
      "(d) the odometer reading:",
      "... - in the event of a change of vehicle during a working day (reading on the vehicle to which he is assigned and reading on the vehicle to which he is to be assigned);",
      "(e) the time of any change of vehicle.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 89,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where all the vehicle change details (time of change, registration and odometer readings) are missing.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 90,
    "code": "c7",
    "title": "Time of vehicle change details omitted/incorrect",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "... (e) the time of any change of vehicle.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 91,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the time of a vehicle change is missing or not entered correctly.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 92,
    "code": "c8",
    "title": "Vehicle change registration omitted/incorrect",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(c) the registration number of each vehicle to which he is assigned, both at the start of the first journey recorded on the sheet and then, in the event of a change of vehicle, during use of the sheet;'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 93,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the registration details a vehicle change is missing or not entered correctly.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 94,
    "code": "c9",
    "title": "Vehicle change odometer readings omitted/incorrect",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(5): 'Each crew member shall enter the following information on his record sheet:",
      "...(d) the odometer reading:",
      "... - in the event of a change of vehicle during a working day (reading on the vehicle to which he is assigned and reading on the vehicle to which he is to be assigned);'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 95,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given where the odometer readings of a vehicle change are missing or not entered correctly.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 96,
    "code": "d1",
    "title": "Time overlap",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.3): ''Time overlap' event. This event shall be triggered when the date/time of last withdrawal of the driver card, as read from the card, is later than the current time/date of the recording equipment in which the card is inserted.'",
      "Annex 1B, paragraph III(3) (Time measurement): '...Time drift shall be within +/- 2 seconds per day in type approval conditions. Time measured shall have a resolution better than or equal to 1 second. Time measured shall not be affected by an external power supply cut-off of less than 12 months in type approval conditions.'",
      "Annex 1B, paragraph III(21) (Time adjustment): 'The time adjustment function shall allow for adjusting the current time in amounts of one minute maximum at intervals of not less than seven days. The time adjustment function shall allow for adjusting the current time without limitation in calibration mode.'",
      "Annex 1B, paragraph VI(4) (Periodic inspections): 'Periodic inspections of the equipment shall take place ...after equipment UTC time is wrong by more than 20 minutes...'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 97,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "An overlap can be the result of a driver changing vehicles where the clocks are not accurately set. The regulation allows an in-use tolerance of up to two seconds per digital tachograph, which corresponds to a maximum total overlap on a single occasion of 4 seconds.",
        "extra": null
      },
      {
        "information": "Examine the data and investigate the circumstances to determine the cause of the overlap.",
        "extra": null
      },
      {
        "information": "Overlaps up to 4 seconds which can be explained with a corresponding vehicle change can be discounted.",
        "extra": null
      },
      {
        "information": "Overlaps of more than four seconds or those that cannot be explained with a vehicle change should be investigated further with a view to taking the appropriate action. UTC time can be adjusted by one minute every seven days without calibration. If the UTC time is out by more than 20 minutes the vehicle must be recalibrated. ",
        "extra": null
      },
      {
        "information": "Drivers must report UTC clock inaccuracies, as they are also legally responsible for ensuring the correct functioning of each tachograph they use.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 98,
    "code": "d2",
    "title": "Card insertion while driving",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(2): Drivers shall use the ... driver cards every day on which they are driving, starting from the moment they take over the vehicle.'",
      "The 1998 case Vehicle Inspectorate v. Anelay (RTR279) stated that in cases of multi-manning, the second man 'takes over' the vehicle on boarding the vehicle, not when he actually begins driving.",
      "Annex 1B, paragraph III(9.5): ''This event shall be triggered when a tachograph card is inserted in any slot while the driver activity is DRIVING.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 99,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This often occurs when driver inserts card in second man position after journey has begun, but equally could be a single driver (or driver one) starting his journey after forgetting to insert his card and then doing it en route.",
        "extra": null
      },
      {
        "information": "Investigate reasons for driver's infringement and take appropriate steps to ensure it does not happen again. ",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 100,
    "code": "d3",
    "title": "Last card session not correctly closed",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.6): ''Last card session not correctly closed' event. This event shall be triggered when at card insertion the recording equipment detects that, despite the provisions laid down in paragraph III(1), the previous card session has not been correctly closed (the card has been withdrawn before all the relevant data have been stored on the card). This event shall be triggered by driver and workshop cards only.",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 101,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code occurs when the card has been withdrawn on a previous shift without storing all the relevant data.",
        "extra": null
      },
      {
        "information": "This code is usually triggered by something that the driver is not able to control – usually it is because there is a fault either with the VU or the card. It could also occur if the driver card was manually removed by a calibration centre (because the VU was faulty and would not eject the card). Check the correct functioning of the card (try it in another VU) and VU (with another card) and take appropriate action -driver to apply for replacement card or VU to be repaired. Also note that this event may also cause excessive driving time and security breach errors. ",
        "extra": null
      }
    ]
  },
  {
    "id": 102,
    "code": "d4",
    "title": "Power supply interruption",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.8): ''Power supply interruption' event. This event shall be triggered, while not in calibration mode, in case of any interruption exceeding 200 milliseconds of the power supply of the motion sensor and/or of the vehicle unit. The interruption threshold shall be defined by the manufacturer. The drop in power supply due to the starting of the engine of the vehicle shall not trigger this event.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 103,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This happens when there is an interruption in the power supply to the motion sensor or the vehicle unit. The interruption must exceed 200 milliseconds and different manufacturers will set different time perimeters for the interruption.",
        "extra": null
      },
      {
        "information": "Managers should examine the data and investigate the circumstances to determine the cause of the interruption of power. It may be explained by a vehicle breakdown, VU malfunction or other unusual mechanical/equipment event, in which case the details should be fully documented.",
        "extra": null
      },
      {
        "information": "In any other case, the circumstances should be investigated and appropriate action taken to ensure it will not happen again.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 104,
    "code": "d5",
    "title": "Motion data error",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.9): ''Motion data error' event. This event shall be triggered in case of interruption of the normal data flow between the motion centre and the vehicle unit and/or in the case of data integrity or data authentication error during data exchange between the motion sensor and the vehicle unit.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 105,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered deliberate omission or falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This error occurs if there is an interruption in the normal flow of data between the motion sensor and the vehicle unit and/or an error occurs during the data exchange between the motion sensor and the vehicle unit which affects the integrity or authentication of that data.",
        "extra": null
      },
      {
        "information": "Managers should examine the data and investigate the circumstances to determine the cause of the motion data error. It may be explained by a vehicle breakdown, VU malfunction or other unusual mechanical/equipment event, in which case the details should be fully documented.",
        "extra": null
      },
      {
        "information": "In any other case, the circumstances should be investigated and appropriate action taken to ensure it will not happen again.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 106,
    "code": "d6",
    "title": "Security breach attempt",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.10): ''Security breach attempt' event. This event shall be triggered for any other event affecting the security of the motion sensor and/or of the vehicle unit as specified within the generic security targets of those components, while not in calibration mode.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 107,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This is triggered by any other event that affects the security of the motion sensor and/or the vehicle unit (other than codes D4 and D5).",
        "extra": null
      },
      {
        "information": "Managers should examine the data and investigate the circumstances to determine the cause of the motion data error. It may be explained by a vehicle breakdown, VU malfunction or other unusual mechanical/equipment event, in which case the details should be fully documented.",
        "extra": null
      },
      {
        "information": "In any other case, the circumstances should be investigated and appropriate action taken to ensure it will not happen again.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 108,
    "code": "d7",
    "title": "Card fault",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.11): ''Card' fault. This fault shall be triggered when a tachograph card failure occurs during operation.",
      "Council Regulation (EEC) No. 3821/85",
      "Article 16(2): '...If the driver card is damaged, malfunctions ...the driver shall, at the end of his journey, printout the information relating to the periods of time recorded by the recording equipment and mark on that document the details that enable him to be identified (the driver card number and/or name and/or driving licence number), including his signature.'",
      "Article 16(2): 'If a driver card is damaged or if it malfunctions, the driver shall return it to the competent authority of the Member State in which he has his normal residence. ...The driver may continue to driver without a driver card for a maximum of 15 calendar days or for a longer period if this is necessary for the vehicle to return to its premises, provided he can prove the impossibility of producing or using the card during this period.'",
      "Article 15(1): '...If a driver card is damaged, malfunctions ...the driver shall apply within seven calendar days for its replacement to the competent authorities of the Member State in which he has his normal residence.",
      "Where a driver card is damaged, malfunctions ...the driver shall:",
      "(a) at the start of his journey, print out the details of the vehicle the driver is driving, and shall enter onto that printout:",
      "(i) details that enable the driver to be identified (name, driver card or driver licence number), including his signature;",
      "(ii) the periods referred to in paragraph 3, second indent (b), (c) and (d);' [namely, other work, periods of availability, breaks from driving and rest] '(b) at the end of his journey, print out the information relating to periods of time recorded by the recording equipment, record any periods of other work, availability and rest undertaken since the printout was made at the start of the journey, where not recorded by the tachograph, and mark on that document details that enable the driver to be identified (name, driver card or driver's licence number) including the driver's signature.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 109,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "Managers should investigate the card fault. Try the driver's card in another VU to verify. Also check another card in the VU to make sure it is not a VU fault (make sure you have pressed 'OK' on the VU to remove the card fault message first) If it is a malfunctioning driver card, the driver must advise DVLA (or DVLNI) and apply for a replacement card within 7 calendar days.",
        "extra": null
      },
      {
        "information": "Managers should ensure drivers have followed the correct procedures in relation to printouts and manual records. Drivers may continue to drive for a maximum of 15 days (unless they need more time for the vehicle to return to base) provided printouts (two per day) and manual records are kept according to the rules (see legal requirements).",
        "extra": null
      },
      {
        "information": "As this may be a driver error – for example if an obviously damaged card has been used, or the fault ignored for some time - you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "If the VU is faulty, ensure the fault is rectified (see code D8).",
        "extra": null
      }
    ]
  },
  {
    "id": 110,
    "code": "d8",
    "title": "Recording equipment fault",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1B, paragraph III(9.12): ''Recording equipment' fault. This fault shall be triggered for any of these failures, while not in calibration mode:",
      "- VU internal fault",
      "- printer fault",
      "- display fault",
      "- downloading fault",
      "- sensor fault.'",
      "Article 16(1): 'In the event of breakdown or faulty operation of the equipment, the employer shall have it repaired by an approved fitter or workshop as soon as circumstances permit. If the vehicle is unable to return to the premises within a period of one week calculated from the day of the breakdown or the discovery of the defective operation, the repair shall be carried out en route.'",
      "Transport Act 1968 Section 97(3): 'A person shall not be liable to be convicted under subsection 1(a) of this section by reason of the recording equipment installed in the vehicle in question not being in working order if he proves to the court that – (a) it had not become reasonably practicable for the equipment to be repaired by an approved fitter or workshop; and (b) the requirements of Article 16(2) of the Community Recording Equipment Regulation were being complied with.'",
      "Council Regulation (EEC) No. 3821/85",
      "Article 16(2): 'While the recording equipment is unserviceable or malfunctioning, drivers shall mark on the record sheet or sheets, or on a temporary sheet to be attached to the record sheet or to the driver card, on which he shall enter data enabling him to be identified (driver's card number and/or name and/or driving licence number), including his signature, all information for the various periods of time which are no longer recorded or printed out correctly by the recording equipment..'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 111,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This can be triggered by any of the following faults:",
        "extra": [
          "VU internal fault",
          "Printer fault",
          "Display fault",
          "Downloading fault",
          "Sensor fault"
        ]
      },
      {
        "information": "Managers should investigate the VU fault. The VU may need to go to an approved tachograph centre for repair and recalibration. See the legislation section for details of when a vehicle with a defective tachograph may be used and the requirements for written records.",
        "extra": null
      },
      {
        "information": "As this may be a driver error – for example if a fault has been ignored by the driver -  you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      }
    ]
  },
  {
    "id": 112,
    "code": "ddd1",
    "title": "Domestic daily drive excessive",
    "law": [
      "Transport Act 1968, Section 96(1): ... a driver shall not on any working day drive a vehicle or vehicles to which this Part of the Act applies for periods amounting in the aggregate to more than ten hours'.",
      "Section 103(3): In this part of this Act references to a person driving a vehicle are references to his being at the driving controls of the vehicle for the purpose of controlling its movement, whether it is in motion or stationary with the engine running.'",
      "Drivers' Hours (Goods Vehicles) (Modifications) Order 1986, Regulation 2(d): 'for the definition of 'working day' in section 103(1) there were substituted the following definition – 'working day', in relation to any driver, means – (a) any working period (that is to say any period during which he is on duty) which does not fall to be aggregated with the whole or part of any other such period or periods by virtue of paragraph (b) of this definition; and (b) where a working period is followed by one or more other such periods beginning within the 24 hours next after the beginning of that working period, the aggregate of that working period and so much of the other such periods as fall within those 24 hours;.'"
    ],
    "penalties": [
      {
        "id": 113,
        "fine": "Fixed penalty: More than 10hrs, but less than 11hrs - £100; 11hrs or more, but less than 12hrs - £200; 12hrs or more - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when a driver has driven for more than 10 hours in a day (24hrs) day. Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. ",
        "extra": null
      }
    ]
  },
  {
    "id": 114,
    "code": "ddu1",
    "title": "Domestic daily duty excessive",
    "law": [
      "Transport Act 1968, Section 96(3): '...the working day of a driver – (a)....shall not exceed eleven hours;'",
      "Section 103(4): In this part of this Act references to a driver being on duty are references – (a) in the case of an employee-driver, to his being on duty (whether for the purpose of driving a vehicle to which this Part of this Act applies or for other purposes) in the employment by virtue of which he is an employee-driver, or in any other employment under the person who is his employer in the first-mentioned employment; and (b) in the case of an owner-driver, to his driving a vehicle to which this Part of the Act applies for the purpose of a trade or business carried on by him or otherwise engaged in work for the purpose of that trade or business, being work in connection with such a vehicle or the load carried thereby.'",
      "Drivers' Hours (Goods Vehicles) (Modifications) Order 1986, Regulation 2(d): 'for the definition of 'working day' in section 103(1) there were substituted the following definition – 'working day', in relation to any driver, means – (a) any working period (that is to say any period during which he is on duty) which does not fall to be aggregated with the whole or part of any other such period or periods by virtue of paragraph (b) of this definition; and (b) where a working period is followed by one or more other such periods beginning within the 24 hours next after the beginning of that working period, the aggregate of that working period and so much of the other such periods as fall within those 24 hours;.'"
    ],
    "penalties": [
      {
        "id": 115,
        "fine": "Fixed penalty: More than 11hrs, but less than 12hrs - £100; 12hrs or more, but less than 13hrs - £200; 13hrs or more £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when a driver has worked for more than 11 hours in a day (24hrs). Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules and that the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 116,
    "code": "ebr1",
    "title": "Insufficient break for cumulative drive/No break taken after cumulative drive",
    "law": [
      "Regulation (EC) No 561/2006 Article 7: 'After a driving period of four and a half hours a driver shall take an uninterrupted break of not less than 45 minutes, unless he takes a rest period.",
      "This break may be replaced by a break of at least 15 minutes followed by a break of at least 30 minutes each distributed over the period in such a way as to comply with the provisions of the first paragraph.'",
      "Article 4(d): ''break' means nay period during which the driver may not carry out any driving or any other work and which is used exclusively for recuperation.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 117,
        "fine": "Fixed penalty: More than 4.5hrs, but less than 5.5hrs - £100; 5.5hrs or more, but less than 6.5hrs - £200; 6.5hrs or more - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 118,
        "description": "Exceed uninterrupted driving time of 4.5h before taking a break:",
        "listing": [
          {
            "id": 119,
            "type": "Serious Infringement",
            "description": "5h or more but less than 6h"
          },
          {
            "id": 120,
            "type": "Very Serious Infringement",
            "description": "6h or more"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code means the driver has driven for more than 4.5 hours without taking the required break. Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules and that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "A common problem is where a driver has split the break from driving, but taken a 30minute break followed by a 15 minute break (the rules require the last break to be at least 30 minutes long). In this instance, the driver needs to be instructed in the correct rules. Also drivers can often misjudge the amount of break recorded and be just a few minutes short – particularly when using a digital tachograph which 'rounds up' driving and so can 'round down' breaks. Drivers should be advised that if in doubt they should take slightly too much break, rather than too little.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 121,
    "code": "edd1",
    "title": "Daily driving excessive",
    "law": [
      "Regulation (EC) No 561/2006 Article 6(1): 'The daily driving time shall not exceed nine hours. ",
      "However, the daily driving time may be extended to at most 10 hours not more than twice during the week.'",
      "Article 4(j): ''driving time' means the duration of driving activity recorded: - automatically or semi-automatically by the recording equipment as defined in Annex 1 or Annex 1B of Regulation (EEC) No 3821/85, or – manually as required by Article 16(2) of Regulation (EEC) No 3821/85;' (see D7 for Article 16(2))",
      "Article 4(k): ''daily driving time' means the total accumulated driving time between the end of one daily rest period and the beginning of the following daily rest period or between a daily rest period and a weekly rest period.'",
      "Article 4(i): ''week' means the period of time between 00.00 on Monday and 24.00 on Sunday.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 122,
        "fine": "Fixed penalty: More than 10hrs, but less than 11hrs - £100; 11hrs or more, but less than 12hrs - £200; 12hrs or more - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 123,
        "description": "When no possibility to extend to 10 hrs drive:",
        "listing": [
          {
            "id": 124,
            "type": "Serious Infringement",
            "description": "10h or more but less than 11h"
          },
          {
            "id": 125,
            "type": "Very Serious Infringement",
            "description": "11h or more but less than 13:30h"
          }
        ]
      },
      {
        "id": 126,
        "description": "Exceed Daily driving of 9hrs by 50% or more when no extensions available and no break or rest of 4.30 hrs taken:",
        "listing": [
          {
            "id": 127,
            "type": "Most Serious Infringement",
            "description": "13:30h or more no break or rest "
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code means the driver has driven for more than 10 hours between daily rests (or between a daily and weekly rest). A common issue can be that digital tachographs 'round up' minutes, but remember in law driving is whatever the tachograph records as driving.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 128,
    "code": "edd2",
    "title": "Daily driving excessive, no extensions available",
    "law": [
      "Regulation (EC) No 561/2006 Article 6(1): 'The daily driving time shall not exceed nine hours. ",
      "However, the daily driving time may be extended to at most 10 hours not more than twice during the week.'",
      "Article 4(j): ''driving time' means the duration of driving activity recorded: - automatically or semi-automatically by the recording equipment as defined in Annex 1 or Annex 1B of Regulation (EEC) No 3821/85, or – manually as required by Article 16(2) of Regulation (EEC) No 3821/85;' (see D7 for Article 16(2))",
      "Article 4(k): ''daily driving time' means the total accumulated driving time between the end of one daily rest period and the beginning of the following daily rest period or between a daily rest period and a weekly rest period.'",
      "Article 4(i): ''week' means the period of time between 00.00 on Monday and 24.00 on Sunday.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 129,
        "fine": "Fixed penalty: More than 9hrs, but less than 10hrs - £100; 10hrs or more, but less than 11hrs - £200; 11hrs or more - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 130,
        "description": "Where extension to 10 available:",
        "listing": [
          {
            "id": 131,
            "type": "Serious Infringement",
            "description": "11h or more but less than 12h"
          },
          {
            "id": 132,
            "type": "Very Serious Infringement",
            "description": "12h or more but less than 15h"
          }
        ]
      },
      {
        "id": 133,
        "description": "Exceed Daily driving of 10hrs by 50% when extensions available and no break or rest of 4.30 hrs taken:",
        "listing": [
          {
            "id": 134,
            "type": "Most Serious Infringement",
            "description": "15h or more"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code means that the driver has driven for more than 9hrs when he/she has no more extensions available within the current fixed week. ",
        "extra": null
      },
      {
        "information": "Common misconceptions can be where the driver believes that he/she has only extended their driving when they have driven to or near 10hrs, rather than just over 9hrs. So, for example they may not understand that a day of 9hrs and five minutes driving counts as one extended driving day. Also, there can be confusion where a driver's working week is different to the fixed week. The rules only allow two extensions per fixed week (00.00 Monday to 24:00 Sunday). Another common issue can be that digital tachographs 'round up' minutes, but remember in law driving is whatever the tachograph records as driving.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 135,
    "code": "edd3",
    "title": "Fortnightly driving excessive",
    "law": [
      "Regulation (EC) No 561/2006 Article 6(3): 'The total accumulated driving time during any two consecutive weeks shall not exceed 90 hours.'",
      "Article 4(j): ''driving time' means the duration of driving activity recorded: - automatically or semi-automatically by the recording equipment as defined in Annex 1 or Annex 1B of Regulation (EEC) No 3821/85, or – manually as required by Article 16(2) of Regulation (EEC) No 3821/85;' (see D7 for Article 16(2))",
      "Article 4(i): ''week' means the period of time between 00.00 on Monday and 24.00 on Sunday.'",
      " Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 136,
        "fine": "Fixed penalty: More than 90hrs, but less than 93hrs - £100; 93hrs or more, but less than 94hrs - £200; 94hrs or more - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 137,
        "description": "Where maximum total driving during 2 consecutive weeks:",
        "listing": [
          {
            "id": 138,
            "type": "Serious Infringement",
            "description": "100h or more but less than 105"
          },
          {
            "id": 139,
            "type": "Very Serious Infringement",
            "description": "105h or more but less than 112h30"
          }
        ]
      },
      {
        "id": 140,
        "description": "Exceed maximum total driving during 2 consecutive weeks by 25% or more:",
        "listing": [
          {
            "id": 141,
            "type": "Most Serious Infringement",
            "description": "112h30 or more "
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code is used where a driver has driven for more than 90 hours in any consecutive two weeks.",
        "extra": null
      },
      {
        "information": "There can be confusion where a driver's working week is different to the fixed week. Another common issue can be that digital tachographs 'round up' minutes, but remember in law driving is whatever the tachograph records as driving.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 142,
    "code": "edd4",
    "title": "Weekly driving excessive",
    "law": [
      "Regulation (EC) No 561/2006 Article 6(2): 'The weekly driving time shall not exceed 56 hours...'",
      "Article 4(j): ''driving time' means the duration of driving activity recorded: - automatically or semi-automatically by the recording equipment as defined in Annex 1 or Annex 1B of Regulation (EEC) No 3821/85, or – manually as required by Article 16(2) of Regulation (EEC) No 3821/85;' (see D7 for Article 16(2))",
      "Article 4(i): ''week' means the period of time between 00.00 on Monday and 24.00 on Sunday.'",
      "Article 4(l): ''weekly driving time' means the total accumulated driving time during the week.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 143,
        "fine": "Fixed penalty: More than 56hrs, but less than 58hrs - £100; 58hrs or more, but less than 59hrs - £200; 59hrs or more - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 144,
        "description": "Exceed weekly driving time:",
        "listing": [
          {
            "id": 145,
            "type": "Serious Infringement",
            "description": "60h or more but less than 65h "
          },
          {
            "id": 146,
            "type": "Very Serious Infringement",
            "description": "65h or more but less than 70h"
          }
        ]
      },
      {
        "id": 147,
        "description": "Exceed weekly driving time by 25% or more:",
        "listing": [
          {
            "id": 148,
            "type": "Most Serious Infringement",
            "description": "70h or more "
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code is used where a driver has driven for more than 56 hours in any fixed week.",
        "extra": null
      },
      {
        "information": "There can be confusion where a driver's working week is different to the fixed week. Another common issue can be that digital tachographs 'round up' minutes, but remember in law driving is whatever the tachograph records as driving.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is also likely to be a scheduling/management error. Audit systems to track drivers hours compliance to prevent future breached.",
        "extra": null
      }
    ]
  },
  {
    "id": 149,
    "code": "edr1",
    "title": "Insufficient daily rest",
    "law": [
      "Regulation (EC) No 561/2006 Article 8(2): 'Within each period of 24 hours after the end of the previous daily rest period or weekly rest period a driver shall have taken a new daily rest period.'",
      "Article 4(g): ''daily rest period' means the daily period during which the driver may freely dispose of his time and covers a 'regular daily rest period and a 'reduced daily rest period':",
      "- 'regular daily rest period' means any period of rest of at least 11 hours. Alternatively, this regular daily rest period may be taken in two periods, the first of which must be an uninterrupted period of at least 3 hours and the second an uninterrupted period of at least nine hours.",
      "- 'reduced daily rest period' means any period of rest that is at least nine hours but less than 11 hours;'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 150,
        "fine": "Fixed penalty: Less than 9hrs, but more than 8hrs - £100; 8hrs or less, but more than 7hrs - £200; 7hrs or less - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 151,
        "description": "Insufficient reduced daily rest period of less than 9h if reduced allowed:",
        "listing": [
          {
            "id": 152,
            "type": "Serious Infringement",
            "description": "Less than 8h but 7h or more"
          },
          {
            "id": 153,
            "type": "Very Serious Infringement",
            "description": "Less than 7h"
          }
        ]
      },
      {
        "id": 154,
        "description": "Insufficient split daily rest period of less than 3h+9h:",
        "listing": [
          {
            "id": 155,
            "type": "Serious Infringement",
            "description": "3h + (less than 8h but 7h or more)"
          },
          {
            "id": 156,
            "type": "Very Serious Infringement",
            "description": "3h +(less than 7h)"
          }
        ]
      },
      {
        "id": 157,
        "description": "Insufficient daily rest of less than 9 hrs for multi manning:",
        "listing": [
          {
            "id": 158,
            "type": "Serious Infringement",
            "description": "Less than 8 hrs but 7h or more"
          },
          {
            "id": 159,
            "type": "Very Serious Infringement",
            "description": "Less than 7h"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code indicates that the driver has failed to take at least 9hrs of rest in 24hr period (or 9hrs in 30 if multi-manned manned and the record indicates multi-manning applies). It is also used when insufficient rest is taken on an interrupted ferry/train daily rest or split rest, again where this is indicated on the record.",
        "extra": null
      },
      {
        "information": "Common problems with this can occur when the driver forgets that the rest needs to be completed within a 24hr period (or 30hr if multi-manning). This period starts when the driver begins duty following a daily or weekly rest. Therefore, in order to ensure a minimum 9hr rest in a 24hr period the maximum shift or spreadover time (from start of duty to end of duty) is 15hrs. Also, drivers can be caught out if shifts start at irregular times, causing them to finish a rest too early.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is also likely to be a scheduling/management error. Audit systems to track drivers hours compliance to prevent future breached.",
        "extra": null
      }
    ]
  },
  {
    "id": 160,
    "code": "edr2",
    "title": "Insufficient daily rest, no reductions left",
    "law": [
      "Regulation (EC) No 561/2006 Article 8(2): 'Within each period of 24 hours after the end of the previous daily rest period or weekly rest period a driver shall have taken a new daily rest period.",
      "If the portion of the daily rest period which falls within that 24 hour period is at least nine hours but less than 11 hours, then the daily rest period in question shall be regarded as a reduced daily rest period.'",
      "Article 8(4): 'A driver may have at most three reduced daily rest periods between any two weekly rest periods.' ",
      "Article 4(g): ''daily rest period' means the daily period during which the driver may freely dispose of his time and covers a 'regular daily rest period and a 'reduced daily rest period':",
      "- 'regular daily rest period' means any period of rest of at least 11 hours. Alternatively, this regular daily rest period may be taken in two periods, the first of which must be an uninterrupted period of at least 3 hours and the second an uninterrupted period of at least nine hours.",
      "- 'reduced daily rest period' means any period of rest that is at least nine hours but less than 11 hours;'",
      "Article 4(h): ''weekly rest period' means the weekly period during which a driver may freely dispose of his time and covers a 'regular weekly rest period' and a 'reduced weekly rest period'.",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 161,
        "fine": "Fixed penalty: Less than 11rs, but more than 10hrs - £100; 10hrs or less, but more than 9hrs - £200; 9hrs or less - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 162,
        "description": "Insufficient daily rest period of less than 11 hrs if reduced rest period not allowed:",
        "listing": [
          {
            "id": 163,
            "type": "Serious Infringement",
            "description": "Less than 10h but 8h30 or more "
          },
          {
            "id": 164,
            "type": "Very Serious Infringement",
            "description": "Less than 8h30"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code is used when the driver has taken less than 11hrs, when he/she has no reductions left in that working week (between weekly rests).",
        "extra": null
      },
      {
        "information": "There can be confusion where a driver's working week is different to the fixed week. Also, problems with this can occur when the driver forgets that the rest needs to be completed within a 24hr period. This period starts when the driver begins duty following a daily or weekly rest. Therefore, in order to ensure a minimum 11hr rest in a 24hr period the maximum shift or spreadover time (from start of duty to end of duty) is 13hrs. Also, drivers can be caught out if shifts start at irregular times, causing them to finish a rest too early.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is also likely to be a scheduling/management error. Audit systems to track drivers hours compliance to prevent future breached.",
        "extra": null
      }
    ]
  },
  {
    "id": 165,
    "code": "ewr1",
    "title": "Failure to take at least one regular weekly rest in 2 consecutive weeks",
    "law": [
      "Regulation (EC) No 561/2006 Article 8(6): 'In any two consecutive weeks a driver shall take at least: - two regular weekly rest periods, or – one regular weekly rest period and one reduced weekly rest period of at least 24 hours.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 166,
        "fine": "Fixed penalty: Less than 45rs, but more than 43hrs - £100; 43hrs or less, but more than 42rs - £200; 42hrs or less - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 167,
        "description": "Insufficient reduced weekly rest period of less than 24hrs:",
        "listing": [
          {
            "id": 168,
            "type": "Serious Infringement",
            "description": "Less than 22h but  20h or more"
          },
          {
            "id": 169,
            "type": "Very Serious Infringement",
            "description": "Less than 20h"
          }
        ]
      },
      {
        "id": 170,
        "description": "Insufficient weekly rest of less than 45h if reduced rest period not allowed:",
        "listing": [
          {
            "id": 171,
            "type": "Serious Infringement",
            "description": "Less than 42h but 36h or more"
          },
          {
            "id": 172,
            "type": "Very Serious Infringement",
            "description": "Less than 36h"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This infringement will be triggered if the driver has not taken at least one weekly rest of at least 45hrs long in any fixed two-week period.",
        "extra": null
      },
      {
        "information": "Weekly rest is the most complex of the drivers' hours rules. Further information can be found in the Logistics UK guide to weekly rest, which includes worked examples to illustrate the rules. We have also produced a weekly rest spreadsheet so that you can schedule work correctly and check for compliance.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is also likely to be a scheduling/management error. Audit systems to track drivers hours compliance to prevent future breached.",
        "extra": null
      }
    ]
  },
  {
    "id": 173,
    "code": "ewr2",
    "title": "Failure to take weekly rest after six 24-hour periods",
    "law": [
      "Regulation (EC) No 561/2006 Article 8(6): '...A weekly rest period shall start no later than at the end of six 24-hour periods from the end of the previous weekly rest period.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 174,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 175,
        "description": "Exceeding 6 consecutive 24h periods following the previous weekly rest:",
        "listing": [
          {
            "id": 176,
            "type": "Serious Infringement",
            "description": "3h or more but less than 12h"
          },
          {
            "id": 177,
            "type": "Very Serious Infringement",
            "description": "12h or more"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code is applied when there is more than 144hrs (6 x 24hrs) between weekly rests.",
        "extra": null
      },
      {
        "information": "Weekly rest is the most complex of the drivers' hours rules. Further information can be found in the Logistics UK guide to weekly rest, which includes worked examples to illustrate the rules. We have also produced a weekly rest spreadsheet so that you can schedule work correctly and check for compliance.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is also likely to be a scheduling/management error. Audit systems to track drivers hours compliance to prevent future breached.",
        "extra": null
      }
    ]
  },
  {
    "id": 178,
    "code": "ewr3",
    "title": "Failure to compensate for reduced weekly rest",
    "law": [
      "Regulation (EC) No 561/2006 Article 8(6): ' ...However, the reduction shall be compensated by an equivalent period of rest taken en bloc before the end of the third week following the week in question.'",
      "Article 8(7): 'Any rest taken as compensation for a reduced weekly rest period shall be attached to another rest period of at least nine hours.'",
      "Article 10: '(1) A transport undertaking shall not give drivers it employs or who are put at its disposal any payment, even in the form of a wage supplement, related to distances travelled and/or the amount of goods carried if that payment is of such a kind as to endanger road safety and/or encourages infringement of this Regulation. (2) A transport undertaking shall organise the work of drivers referred to in paragraph 1 in such a way that the drivers are able to comply with ... Chapter II of this Regulation. The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that  ...Chapter II of this Regulation are complied with.'"
    ],
    "penalties": [
      {
        "id": 179,
        "fine": "Fixed penalty: Up to 3hrs less rest than required - £100; 3hrs or more but less than 4hrs less rest than required - £200; 4hrs or more less rest than required - £300",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used where weekly rest reductions have not been compensated. If a driver reduces weekly rest the reduction must be compensated in en bloc by the end of the third following week, attaching it to another rest period of at least 9hrs.",
        "extra": null
      },
      {
        "information": "A common problem can occur when a reduction is split into smaller blocks of time and compensated – but this is not permitted. For example a reduced weekly rest of 24hrs represents a reduction of 21hrs (45-24). This must be compensated in one block and added to a period of at least 9hrs long. So this means the minimum rest period to compensate for this is 30hrs in total.",
        "extra": null
      },
      {
        "information": "Weekly rest is the most complex of the drivers' hours rules. Further information can be found in the Logistics UK guide to weekly rest, which includes worked examples to illustrate the rules. We have also produced a weekly rest spreadsheet so that you can schedule work correctly and check for compliance.",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules, that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is also likely to be a scheduling/management error. Audit systems to track drivers hours compliance to prevent future breached.",
        "extra": null
      }
    ]
  },
  {
    "id": 180,
    "code": "f1",
    "title": "Overlapping traces. This code is applied where there appears to be one trace overlapping another. ",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): '... No record sheet...may be used to cover a period longer than that for which it is intended.'",
      "Annex 1(f)(3)(c) (in use tolerances): 'time: + or – two minutes per day, or + or – 10 minutes per seven days",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 181,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when traces on the chart overlap.",
        "extra": null
      },
      {
        "information": "Managers should examine the tachograph chart and investigate the circumstances to determine whether the overlap signifies an infringement by the driver or that the recording equipment needs recalibrating. ",
        "extra": null
      },
      {
        "information": "An overlap can be the result of a driver changing vehicles where the clocks are not accurately set. The regulation allows an in-use tolerance of up to two minutes per tachograph, which corresponds to a maximum total overlap on a single trace of 4 minutes.",
        "extra": null
      },
      {
        "information": "Overlaps up to 4 minutes which can be explained with a corresponding vehicle change can be discounted.",
        "extra": null
      },
      {
        "information": "Overlaps of more than four minutes or those that cannot be explained with a vehicle change should be investigated further with a view to taking the appropriate action (such as recalibration of equipment).",
        "extra": null
      },
      {
        "information": "If a driver has used a record sheet for more than 24 hours (see also I2) or used the same sheet more than once, an infringement has occurred.",
        "extra": null
      },
      {
        "information": "Drivers must report clock inaccuracies of more than two minutes, as they are also legally responsible for ensuring the correct functioning of each tachograph they use. ",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 182,
    "code": "f2",
    "title": "No traces recorded",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 183,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code will be applied when all the trace lines are missing and the driver has not made any manual entries to account for his activities, this could be for the whole or part of a shift.",
        "extra": null
      },
      {
        "information": "This usually indicates that the equipment has failed to record – possibly because the chart has failed to turn properly, or the chart was placed in the head upside-down.",
        "extra": null
      },
      {
        "information": "Investigate to determine if this is an equipment malfunction or driver error. Other codes (such as F6, R2 or R3) may also help to narrow this down.",
        "extra": null
      },
      {
        "information": "Where equipment is faulty arrange for it to be repaired as soon as possible.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where this is a driver error, or where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 184,
    "code": "f3",
    "title": "Speed trace irregularity",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1, III (f) 3 (in use tolerances): '(b) speed: 6 km/h more or less than the real speed'.",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 185,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code will be applied to speed trace irregularities which are unrelated to the base line – in other words for reasons other than the trace being too high or too low on the chart (we use code F7 for that).",
        "extra": null
      },
      {
        "information": "The speed trace could be unusually thick or thin, have intermittent gaps.",
        "extra": null
      },
      {
        "information": "One of the most common irregularities is caused by oil in the sender unit which produces a thick and black block in the speed trace.",
        "extra": null
      },
      {
        "information": "Examine the tachograph chart and decide whether the irregularity makes the trace in any way illegible or inaccurate above the 6km tolerance – if so make arrangements to have the tachograph repaired to the required standard.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where this is a driver error, or where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 186,
    "code": "f4",
    "title": "Activity trace irregularity",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 187,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code will be applied to activity trace irregularities. The trace could be unusually thick or thin, have intermittent gaps.",
        "extra": null
      },
      {
        "information": "Common irregularities include a faint activity trace, 'rounding' of the trace and the continuation of the trace in drive when the distance and speed traces indicate the vehicle is stationary.",
        "extra": null
      },
      {
        "information": "Examine the tachograph chart and decide whether the irregularity makes the distance trace in any way illegible or inaccurate – if so make arrangements to have the tachograph repaired to the required standard.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where this is a driver error, or where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 188,
    "code": "f5",
    "title": "Distance trace irregularity",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1, III(c)2.2: 'Even at speeds reaching the upper limit range of the measurement, the record of distances must still be clearly legible.'",
      "Annex 1, III (f) 3 (in use tolerances): '(a) distance travelled: 2% more or less than the real distance, where that distance is at least 1 kilometre'",
      "Article 14(1): '...The employer shall issue to drivers only sheets of an approved model suitable for use in the equipment installed in the vehicle.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 189,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code will be applied to distance trace irregularities. The trace could be unusually thick or thin, have intermittent gaps.",
        "extra": null
      },
      {
        "information": "One of the most common irregularities is where the 'V's do not deflect fully to form a full V-shape. Another is where the distance trace is recording too low and encroaching into the centerfield. (However, note that if all traces are low, this may indicate that an incorrect chart has been used – see I8).",
        "extra": null
      },
      {
        "information": "Examine the tachograph chart and decide whether the irregularity makes the distance trace in any way illegible or inaccurate – if so make arrangements to have the tachograph repaired to the required standard.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where this is a driver error, or where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 190,
    "code": "f6",
    "title": "Discontinuity of distance trace",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 191,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is applied when the distance trace does not follow on from where it last finished.",
        "extra": null
      },
      {
        "information": "Common reasons for this are that the vehicle ahs been moved without a chart in or the driver has changed vehicles without manual entries indicating the reasons or the change on the chart.",
        "extra": null
      },
      {
        "information": "Investigate the infringement and take appropriate action to prevent re-occurrence.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where equipment is faulty arrange for it to be repaired as soon as possible.",
        "extra": null
      },
      {
        "information": "Where this is a driver error, or where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 192,
    "code": "f7",
    "title": "Speed trace base line high/low",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Annex 1, III (f) 3 (in use tolerances): '(b) speed: 6 km/h more or less than the real speed'.",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 193,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "If the speed trace is sitting consistently above or below the baseline with a gap larger than approximately 6kph (level with the centre of number 3 or 8) then this code will be applied.",
        "extra": null
      },
      {
        "information": "Examine the tachograph chart and decide whether the trace is in any way illegible or inaccurate above the 6km tolerance – if so make arrangements to have the tachograph repaired to the required standard. (However, note that if all traces are low, this may indicate that an incorrect chart has been used – see I8).",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 194,
    "code": "f8",
    "title": "Traces malfunctioning/illegible",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 195,
        "fine": "Fixed penalty £100",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code indicates that more than one trace has irregularities, such as gaps or appearing too thin or thick, high or low.",
        "extra": null
      },
      {
        "information": "Examine the tachograph chart and decide whether the irregularities make the traces in any way illegible or inaccurate – if so make arrangements to have the tachograph repaired to the required standard.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where this is a driver error, or where a driver has ignored a fault, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 196,
    "code": "i2",
    "title": "Chart trace overrun",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): '... No record sheet...may be used to cover a period longer than that for which it is intended.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 197,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when a chart has been left in the head for more than 24hrs. ",
        "extra": null
      },
      {
        "information": "This is common where a driver has left a chart in overnight on rest but has started work slightly later the next day causing the traces to overrun. If the chart has been left to overrun for a long time, particularly in what appears to be the wrong mode, then it may not be possible to analyse the chart.",
        "extra": null
      },
      {
        "information": "",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 198,
    "code": "i3",
    "title": "Start and finish lines/times required* (Special Instruction only)",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "European Court of Justice ruling in 2001(Skills Coaches Ltd) ruled:'...the obligation to record such a period [other periods of work] applies ... regardless of whether it precedes the taking over of a tachograph vehicle.' ",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on  the chart provided they are clear and do not obliterate other recordings.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": null,
    "infringements": null,
    "advice": [
      {
        "information": "This code is only used when special instructions have been received by Logistics UK to check for this.",
        "extra": null
      },
      {
        "information": "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Where this may be a driver failing to comply with a reasonable request you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 199,
    "code": "i4",
    "title": "Start and finish lines/times must be labelled* (Special Instruction only)",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "European Court of Justice ruling in 2001(Skills Coaches Ltd) ruled:'...the obligation to record such a period [other periods of work] applies ... regardless of whether it precedes the taking over of a tachograph vehicle.' ",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on  the chart provided they are clear and do not obliterate other recordings.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": null,
    "infringements": null,
    "advice": [
      {
        "information": "This code is only used when special instructions have been received by Logistics UK to check for this.",
        "extra": null
      },
      {
        "information": "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Where this may be a driver failing to comply with a reasonable request you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 200,
    "code": "i5",
    "title": "Distance traces and odometer totals do not correspond",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised...'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 201,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "The balance of the odometer readings provided on the chart should agree with the distance traces (each complete 'V' equals 10km. each complete side is 5km) and this code is applied when the totals do not match.",
        "extra": null
      },
      {
        "information": "The most common reason for this is where the odometer reading has been incorrectly entered – particularly look for transposed numbers. Odometer readings on previous charts or fuel records may help to determine this.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 202,
    "code": "i6",
    "title": "Head may not be closed properly",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised...'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 203,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "The tachograph records the opening and closing of the tachograph head. This code is used where frequent opening and closing of the head have been recorded which suggest the head may not be properly closed. Gaps will be visible throughout all the traces with a distinctive 'tail' on the end of each trace.",
        "extra": null
      },
      {
        "information": "Interview the driver and investigate to establish the reason for the frequent opening recordings and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where equipment is faulty arrange for it to be repaired as soon as possible.",
        "extra": null
      },
      {
        "information": "As this may be a driver error – the head may not have been closed properly or the driver may be opening the head for inappropriate reasons - you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with equipment, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 204,
    "code": "i7",
    "title": "Head may have been opened at speed",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 205,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "The tachograph records the opening and closing of the tachograph head. This code is used where the head appears to have been opened whilst the vehicle was in motion. Gaps will be visible throughout all the traces with a distinctive 'tail' on the end of each trace.",
        "extra": null
      },
      {
        "information": "The legislation states that the chart should not be removed from the head before the end of duty unless 'otherwise authorised'. The rules are not specific on who can authorise removal, but cases where charts can be removed include a change of vehicle or to make manual entries in the event of an emergency, equipment malfunction etc.",
        "extra": null
      },
      {
        "information": "Opening the head whilst the vehicle in motion however, is unlikely to be considered authorised as this prevents driving time from being recorded and is likely to arouse the suspicions of enforcement officers. ",
        "extra": null
      },
      {
        "information": "Interview the driver and investigate to establish the reason for the head opening and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Where equipment is faulty arrange for it to be repaired as soon as possible.",
        "extra": null
      },
      {
        "information": "As this may be a driver error – the head may not have been closed properly - you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with the record, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 206,
    "code": "i8",
    "title": "Wrong chart may have been used",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 14(1): '...The employer shall issue to drivers only sheets of an approved model suitable for use in the equipment installed in the vehicle.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 207,
        "fine": "",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": false
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears that an incorrect chart has been used. Managers should check that the 'e' number and speed gradient on the chart match the tachograph. Where an incorrect chart was used, this is an infringement committed primarily by the employer. The manager must take steps to ensure that the correct charts are issued in future. Where a correct chart has been used, check the functioning of the tachograph and the chart.",
        "extra": null
      }
    ]
  },
  {
    "id": 208,
    "code": "i9",
    "title": "Chart may have been inserted incorrectly",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 209,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears the chart may not have been inserted correctly.",
        "extra": null
      },
      {
        "information": "The chart may have been put in upside down (in which case the driver should have explained this on the chart and used manual entries to account for his activities) or inserted incorrectly, which sometimes rips or distorts the centre hole and prevents accurate recordings.",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 210,
    "code": "k1",
    "title": "Clock possibly 12 hours out",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(3): 'Drivers shall: - ensure that the time recorded on the sheet agrees with the official time in the country of registration of the vehicle.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 211,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears that the clock may be inaccurate by 12hrs. Drivers are specifically required to ensure the tachograph time is correctly adjusted to the official time of the country of registration. A 12-hour difference may have occurred following a repair or recalibration where the clock has been set to the wrong 12-hour period. However, this should have also been picked up and reported by the driver.",
        "extra": null
      },
      {
        "information": "Where a driver finds the clock is showing an incorrect time during his working period he should make a note on the back of the chart as soon as possible, but should not adjust the time until the end of the working period – otherwise an overlap or gap will appear in the record.",
        "extra": null
      },
      {
        "information": "Investigate the problem and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 212,
    "code": "k2",
    "title": "Clock possible 1 hour out",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(3): 'Drivers shall: - ensure that the time recorded on the sheet agrees with the official time in the country of registration of the vehicle.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 213,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears that the clock may be inaccurate by an hour. Drivers are specifically required to ensure the tachograph time is correctly adjusted to the official time of the country of registration. For UK registered vehicles, the most common reason for an hour's difference is the change to and from British Summer Time (BST) at 01:00 on the last Sunday in March (clocks go forward one hour) and the last Sunday in October (clocks go back one hour). A recent repair or recalibration may also explain the problem. However, this should have also been picked up and reported by the driver.",
        "extra": null
      },
      {
        "information": "Where a driver finds the clock is showing an incorrect time during his working period he should make a note on the back of the chart as soon as possible, but should not adjust the time until the end of the working period – otherwise an overlap or gap will appear in the record.",
        "extra": null
      },
      {
        "information": "Investigate and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission or falsification with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 214,
    "code": "m1",
    "title": "Apparent misuse of mode switch",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(3): 'Drivers shall: - ...operate the switch mechanisms enabling the following periods of time to be recorded separately and distinctly:' [legislation then shows signs for driving, other work, availability and breaks and rest]",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 215,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears that the driver may not have used the mode switch on the tachograph correctly. The driver is legally required to produce a full and accurate record and in particular to ensure the correct mode is selected when the vehicle is stationary. For drivers, digital tachographs default to other work when the vehicle stops moving, but analogue tachographs default to the last mode selection. A common problem can occur with analogue tachographs when a driver drives off following a rest/break period or POA and forgets to change the mode switch to show other work throughout the rest of, or large parts of the shift.",
        "extra": null
      },
      {
        "information": "As most drivers are likely to carry out some other work (routine vehicle checks, paperwork, loading and unloading etc.), this code is used when there is very little or no other work recorded - where the record consistently toggles between driving and rest/break or riving and POA.",
        "extra": null
      },
      {
        "information": "Investigate the driver's shift on that day to determine if the record accurately matches the activities. If the driver's duty only consisted of driving and rest/break or POA, then no offence has occurred. However, if this is a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that records errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      }
    ]
  },
  {
    "id": 216,
    "code": "m2",
    "title": "Mode left on work overnight",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(3): 'Drivers shall: - ...operate the switch mechanisms enabling the following periods of time to be recorded separately and distinctly:' [legislation then shows signs for driving, other work, availability and breaks and rest]",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 217,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears that the driver may have incorrectly left the tachograph mode on 'other work' during a rest period. The driver is legally required to produce a full and accurate record and in particular to ensure the correct mode is selected when the vehicle is stationary. For drivers, digital tachographs default to other work when the vehicle stops moving and analogue tachographs default to the last mode selection. A common problem can occur when the driver leaves his chart or card in the tachograph during the daily rest period and forgets to change the mode switch to show rest. This code is used when this appears to have happened. ",
        "extra": null
      },
      {
        "information": "Investigate the driver's shift on that day to determine if the record accurately matches the activities. If the record is accurate, there are likely to be daily and/or weekly rest infringements to investigate. If the record is inaccurate, the driver has committed a records offence. It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 218,
    "code": "m3",
    "title": "Mode left on available overnight",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(3): 'Drivers shall: - ...operate the switch mechanisms enabling the following periods of time to be recorded separately and distinctly:' [legislation then shows signs for driving, other work, availability and breaks and rest]",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 219,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when it appears that the driver may have incorrectly left the tachograph mode on 'avaiability' during a rest period. The driver is legally required to produce a full and accurate record and in particular to ensure the correct mode is selected when the vehicle is stationary. For drivers, digital tachographs default to other work when the vehicle stops moving and analogue tachographs default to the last mode selection. A common problem can occur when the driver leaves his chart or card in the tachograph during the daily rest period and forgets to change the mode switch to show rest. This code is used when this appears to have happened. ",
        "extra": null
      },
      {
        "information": "Investigate the driver's shift on that day to determine if the record accurately matches the activities. If the record is accurate, there are likely to be daily and/or weekly rest infringements to investigate. If the record is inaccurate, the driver has committed a records offence. It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 220,
    "code": "r1",
    "title": "Inaccurate/incomplete record",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "European Court of Justice ruling in 2001(Skills Coaches Ltd) ruled:'...the obligation to record such a period [other periods of work] applies ... regardless of whether it precedes the taking over of a tachograph vehicle.'",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
      "Annex 1(f)(3)(c) (in use tolerances): 'time: + or – two minutes per day, or + or – 10 minutes per seven days",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 221,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is given when log sheets are added to Vision and the data on the sheet is incomplete.",
        "extra": null
      }
    ]
  },
  {
    "id": 222,
    "code": "r2",
    "title": "Gaps between lines and traces require explanation",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "European Court of Justice ruling in 2001(Skills Coaches Ltd) ruled:'...the obligation to record such a period [other periods of work] applies ... regardless of whether it precedes the taking over of a tachograph vehicle.'",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
      "Annex 1(f)(3)(c) (in use tolerances): 'time: + or – two minutes per day, or + or – 10 minutes per seven days",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 223,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when there is an unexplained gap between the activity traces and a manual entry, particularly start of duty or end of duty line marked on the tachograph. Logistics UK analysts only code for gaps of more than two minutes (the tachograph time tolerance).",
        "extra": null
      },
      {
        "information": "Drivers are legally required to provide a full and accurate record of their daily working period by using the recording equipment or where this is not possible by way of manual entry. All gaps in records of the driver's daily working period outside the tachograph time tolerances (plus or minus two minutes per day) are infringements. It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Managers should investigate the reason for the gap to ensure action is taken to prevent its reoccurrence.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Unexplained gaps are analysed as other work, so they could also lead to drivers' hours and working time rules infringements.",
        "extra": null
      }
    ]
  },
  {
    "id": 224,
    "code": "r3",
    "title": "Gaps between traces require explanation",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "Annex 1(f)(3)(c) (in use tolerances): 'time: + or – two minutes per day, or + or – 10 minutes per seven days",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 225,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when there is an unexplained gap between the activity traces. Logistics UK analysts only code for gaps of more than two minutes (the tachograph time tolerance).",
        "extra": null
      },
      {
        "information": "Drivers are legally required to provide a full and accurate record of their daily working period by using the recording equipment or where this is not possible by way of manual entry. All gaps in records of the driver's daily working period outside the tachograph time tolerances (plus or minus two minutes per day) are infringements. It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Managers should investigate the reason for the gap to ensure action is taken to prevent its reoccurrence.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Unexplained gaps are analysed as other work, so they could also lead to drivers' hours and working time rules infringements.",
        "extra": null
      }
    ]
  },
  {
    "id": 226,
    "code": "r6",
    "title": "Start line is inaccurate",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "European Court of Justice ruling in 2001(Skills Coaches Ltd) ruled:'...the obligation to record such a period [other periods of work] applies ... regardless of whether it precedes the taking over of a tachograph vehicle.'",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
      "Annex 1(f)(3)(c) (in use tolerances): 'time: + or – two minutes per day, or + or – 10 minutes per seven days",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 227,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used where the line drawn on a chart to indicate the start of a shift appears to be inaccurate because it differs by more than 2 minutes from the chart traces or manual entries. It is also used if the top and bottom of the line differ by more than 10 minutes.",
        "extra": null
      },
      {
        "information": "Drivers are legally required to provide a full and accurate record of their daily working period. It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Managers should investigate the reason for the gap to ensure action is taken to prevent its reoccurrence. If the error occurred because of a difference between the top and bottom of the line, one solution may be to ask the driver to draw a shorter line (at the top, as this is less likely to interfere with chart traces).",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 228,
    "code": "r7",
    "title": "Finish line is inaccurate",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): Drivers shall use the record sheets ... every day on which they are driving, starting from the moment they take over the vehicle. The record sheet ... shall not be withdrawn before the end of the daily working period unless its withdrawal is otherwise authorised... When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Drivers must produce a record of their whole daily working period...Employers may also ask drivers to indicate on a chart where their duty (or rest) begins and ends, so that they can ensure that a full record has been submitted. ' and 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
      "Annex 1(f)(3)(c) (in use tolerances): 'time: + or – two minutes per day, or + or – 10 minutes per seven days",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 229,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used where the line drawn on a chart to indicate the end of a shift appears to be inaccurate because it differs by more than 2 minutes from the chart traces or manual entries. It is also used if the top and bottom of the line differ by more than 10 minutes.",
        "extra": null
      },
      {
        "information": "Drivers are legally required to provide a full and accurate record of their daily working period. It can sometimes mistakenly be believed that record errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "Managers should investigate the reason for the gap to ensure action is taken to prevent its reoccurrence. If the error occurred because of a difference between the top and bottom of the line, one solution may be to ask the driver to draw a shorter line (at the top, as this is less likely to interfere with chart traces).",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 230,
    "code": "r9",
    "title": "Inaccurate record",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(3): 'Drivers shall: - ...operate the switch mechanisms enabling the following periods of time to be recorded separately and distinctly:' [legislation then shows signs for driving, other work, availability and breaks and rest]",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 231,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate falsification or omission with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "Code is given when a driver has made an incorrect manual entry or left their card in overnight on activity other than rest. When the data is amended this code is automatically assigned to the date.",
        "extra": null
      }
    ]
  },
  {
    "id": 232,
    "code": "s1",
    "title": "Speed trace in excess of 90kph that may indicate speed limiter fault",
    "law": [
      "Regulations 36A and 36B of the Road Vehicles (Construction and Use) Regulations 1986 (as amended) requires certain vehicles to have a speed limiter fitted which must be set so that the stabilised speed of the vehicle must not exceed 90kph (56mph). ",
      "The holder of an operator's licence signs a declaration stating that: 'The licenced operator UNDERTAKES to make proper arrangements so that: the laws relating to the driving and operation of vehicles are observed .... I understand that the above undertakings will be recorded on the licence. Failure to comply with the conditions or undertakings recorded on the licence may result in the licence being revoked, suspended or curtailed.'",
      "Vehicle operators are obliged to inform Traffic Commissioners about any relevant notifiable convictions (which includes defective speed limiters) received by them or their servants or agents. These are taken into account when determining the operator's fitness to hold a licence or good repute."
    ],
    "penalties": [
      {
        "id": 233,
        "fine": "Fixed penalty £200",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "Any incident of speeds over 56mph recorded on a tachograph is reported in analysis, as it is potentially an indication that the vehicle's speed limiter is not functioning correctly. If you believe this is not the relevant speed limiter threshold for this vehicle, contact TachoLogistics UK.",
        "extra": null
      },
      {
        "information": "The speed limiter serves only to restrict power to the drive wheels once 56mph is reached. It will not restrict the vehicle when travelling down a hill and the momentum of the vehicle may carry the vehicle over this speed. However, this does not remove the obligation for managers to investigate every over-speed incident in a systematic and effective way to ensure speed limiters are working and the organisation's operator's licence is safeguarded.",
        "extra": null
      },
      {
        "information": "Having considerable numbers of over speed events reported on analysis means that managers' time may be wasted carrying out unnecessary investigations, and arrangements for compliance are undermined. Therefore, it is advisable that drivers are required to be aware of their vehicle's speed and take action where necessary ensure that 56mph is not exceeded (e.g. apply the brakes). ",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the over-speed event and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Where this may be a driver failing to comply with a reasonable request you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with the speed limiter, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 234,
    "code": "s2",
    "title": "Speed trace in excess of 100kph may indicate speed limiter fault",
    "law": [
      "Regulations 36A and 36B of the Road Vehicles (Construction and Use) Regulations 1986 (as amended) requires certain vehicles to have a speed limiter fitted which must be set so that the stabilised speed of the vehicle must not exceed 100kph (around 60mph). A person or organisation using a vehicle which does not have a functioning speed limiter fitted is committing a criminal offence under Section 42 of the Road Traffic Act 1988 (as amended), which carries a maximum fine of £2,500.",
      "For certain large goods and passenger vehicles the maximum permissible road speed on any road is 60mph. Section 89 of the Road Traffic Regulation Act 1984 makes it an offence to drive above the speed limit.",
      "The holder of an operator's licence signs a declaration stating that: 'The licenced operator UNDERTAKES to make proper arrangements so that: the laws relating to the driving and operation of vehicles are observed .... I understand that ...failure to comply with the conditions or undertakings recorded on the licence may result in the licence being revoked, suspended or curtailed.' ",
      "Vehicle operators are obliged to inform Traffic Commissioners about any relevant notifiable convictions (which include defective speed limiters and speeding) received by them or their servants or agents. These are taken into account when determining the operator's fitness to hold a licence or good repute."
    ],
    "penalties": [
      {
        "id": 235,
        "fine": "Fixed penalty £200 - speed limiter fault",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      },
      {
        "id": 236,
        "fine": "Fixed penalty £100 plus 3 penalty points - if exceeding road speeds",
        "description": [
          "If taken to court maximum fine of £1,000 per offence, obligatory 3-6 penalty points and discretionary disqualification from driving."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "Any incident of speeds over 60mph recorded on a tachograph is reported in analysis, as it is potentially an indication that the vehicle's speed limiter is not functioning correctly and/or that a road speed limit has been exceeded. If you believe this is not the relevant speed limiter/speed limit threshold for this vehicle, contact TachoLogistics UK.",
        "extra": null
      },
      {
        "information": "The speed limiter serves only to restrict power to the drive wheels once 60mph is reached. It will not restrict the vehicle when travelling down a hill and the momentum of the vehicle may carry the vehicle over this speed. However, this does not remove the obligation for managers to investigate every over-speed incident in a systematic and effective way to ensure speed limiters are working and the organisation's operator's licence is safeguarded.",
        "extra": null
      },
      {
        "information": "Having considerable numbers of over speed events reported on analysis means that managers' time may be wasted carrying out unnecessary investigations, and arrangements for compliance are undermined. Therefore, it is advisable that drivers are required to be aware of their vehicle's speed and take action where necessary ensure that 60mph is not exceeded (e.g. apply the brakes). ",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the over-speed event and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Where this may be a driver failing to comply with a reasonable request you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with the speed limiter or a speeding offence, which are both a very serious offences, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 237,
    "code": "s3",
    "title": "Speed trace in excess of 113kph may indicate speed limiter fault",
    "law": [
      "Regulations 36A and 36B of the Road Vehicles (Construction and Use) Regulations 1986 (as amended) requires certain vehicles to have a speed limiter fitted which must be set so that the stabilised speed of the vehicle must not exceed around 113kph (70mph). A person or organisation using a vehicle which does not have a functioning speed limiter fitted is committing a criminal offence under Section 42 of the Road Traffic Act 1988 (as amended), which carries a maximum fine of £2,500.",
      "For most vehicles the maximum permissible road speed on any road is 70mph. Section 89 of the Road Traffic Regulation Act 1984 makes it an offence to drive above the speed limit.",
      "The holder of an operator's licence signs a declaration stating that: 'The licenced operator UNDERTAKES to make proper arrangements so that: the laws relating to the driving and operation of vehicles are observed .... I understand that ...failure to comply with the conditions or undertakings recorded on the licence may result in the licence being revoked, suspended or curtailed.' ",
      "Vehicle operators are obliged to inform Traffic Commissioners about any relevant notifiable convictions (which include defective speed limiters and speeding) received by them or their servants or agents. These are taken into account when determining the operator's fitness to hold a licence or good repute."
    ],
    "penalties": [
      {
        "id": 238,
        "fine": "Fixed penalty £200 - speed limiter fault",
        "description": [
          "If taken to court maximum fine of £2,500 per offence."
        ],
        "disclaimer": true
      },
      {
        "id": 239,
        "fine": "Fixed penalty £100 plus 3 penalty points - if exceeding road speeds",
        "description": [
          "If taken to court maximum fine of £1,000 per offence, obligatory 3-6 penalty points and discretionary disqualification from driving."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "Any incident of speeds over 70mph recorded on a tachograph is reported in analysis, as it is potentially an indication that the vehicle's speed limiter is not functioning correctly and/or that a road speed limit has been exceeded. If you believe this is not the relevant speed limiter/speed limit threshold for this vehicle, contact TachoLogistics UK.",
        "extra": null
      },
      {
        "information": "The speed limiter serves only to restrict power to the drive wheels once 70mph is reached. It will not restrict the vehicle when travelling down a hill and the momentum of the vehicle may carry the vehicle over this speed. However, this does not remove the obligation for managers to investigate every over-speed incident in a systematic and effective way to ensure speed limiters are working and the organisation's operator's licence is safeguarded.",
        "extra": null
      },
      {
        "information": "Having considerable numbers of over speed events reported on analysis means that managers' time may be wasted carrying out unnecessary investigations, and arrangements for compliance are undermined. Therefore, it is advisable that drivers are required to be aware of their vehicle's speed and take action where necessary ensure that 70mph is not exceeded (e.g. apply the brakes). ",
        "extra": null
      },
      {
        "information": "Interview the driver to establish the reason for the over-speed event and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Where this may be a driver failing to comply with a reasonable request you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately interfering with the speed limiter or a speeding offence, which are both a very serious offences, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 240,
    "code": "t1",
    "title": "Manual entries obscuring chart traces",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 13: 'The employer and drivers shall ensure the correct functioning and proper use of... the recording equipment.'",
      "Article 15(2): When as a result of being away from the vehicle, a driver is unable to use the equipment fitted to the vehicle, the periods of time referred to in paragraph 3, second indent (b) [other work], (c) [availability] and (d) [breaks in work and daily rest periods] shall ... be entered on the record sheet, either manually, by automatic recording or other means, legibly and without dirtying the sheet...'",
      "DVSA Rules on Drivers' Hours and Tachographs (GV262) confirms: 'Most analogue charts have a specified place to make manual entries (usually on the reverse). However, manual entries may be made anywhere on the chart provided they are clear and do not obliterate other recordings.'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 241,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate destruction of record with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code is used when the manual entries applied to the chart by the driver are interfering with the chart traces. Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately defacing the record, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 242,
    "code": "t2",
    "title": "Chart dirty/damaged/marked",
    "law": [
      "Council Regulation (EEC) No. 3821/85",
      "Article 15(1): 'Drivers shall not use dirty or damaged record sheets or driver cards. The sheets or driver cards shall be adequately protected on this account.'",
      "Article 14(1): 'The employer shall issue a sufficient number of record sheets to drivers ... bearing in mind ... the possible obligation to replace sheets which are damaged...'",
      "Regulation (EC) No 561/2006 Article 10(2): 'A transport undertaking shall organise the work of drivers referred to in paragraph 1' [It employs or who are put at its disposal] 'in such a way that the drivers are able to comply with Regulation (EEC) 3821/85... The transport undertakings shall properly instruct the driver and shall make regular checks to ensure that Regulation (EEC) 3821/85 ...are complied with.'"
    ],
    "penalties": [
      {
        "id": 243,
        "fine": "Fixed penalty £50",
        "description": [
          "If taken to court maximum fine is unlimited per offence.",
          "If considered a deliberate destruction of record with intent to deceive up to two years in prison plus a fine on indictment."
        ],
        "disclaimer": true
      }
    ],
    "infringements": [
      {
        "id": 244,
        "description": "",
        "listing": [
          {
            "id": 245,
            "type": "Very Serious Infringement",
            "description": "Use dirty or damaged record sheets or drivers card and data not legible"
          }
        ]
      }
    ],
    "advice": [
      {
        "information": "This code is used when the chart is dirty, damaged or marked. Interview the driver to establish the reason for the error and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "It can sometimes mistakenly be believed that chart errors are minor problems. This is not so. Remind the driver that the maximum penalties for records infringements are double those of hours infringements (up to £5,000 per offence, rather than £2,500) and if considered by a court to be a deliberate omission with intent to deceive the driver could face up to two years in prison plus a fine on indictment.",
        "extra": null
      },
      {
        "information": "As this is a driver error, you should also look to your organisation's policy on training and disciplinary processes, as appropriate.",
        "extra": null
      },
      {
        "information": "Where this is proven to be a driver deliberately defacing the record, which is a very serious offence, you should look to your organisation's disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 246,
    "code": "wbr1",
    "title": "Insufficient breaks in working day",
    "law": [
      "The Road Transport (Working Time) Regulations 2005",
      "Regulation 7: '(1) No mobile worker shall work for more than six hours without a break. (2) Where a mobile worker's working time exceeds six hours, but does not exceed nine hours, the worker shall be entitled to a break lasting at least 30 minutes and interrupting that time. (3) Where a mobile worker's working time exceeds nine hours, the worker shall be entitled to a break lasting at least 45 minutes and interrupting that time. (4) Each break may be made up of separate periods of not less than 15 minutes each. (5) An employer shall take all reasonable steps, in keeping with the need to protect the health and safety of the mobile worker, to ensure that the limits specified above are complied with in the case of each mobile worker employed by him.'"
    ],
    "penalties": [
      {
        "id": 247,
        "fine": "",
        "description": [
          "Penalties range from the issue of an improvement notice (giving a period of time to put the problem right), a prohibition notice (prohibiting operations until the problem is rectified) to unlimited fines and up to two years in prison on indictment."
        ],
        "disclaimer": false
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code means the driver has worked for more than 6hrs without taking the required break (minimum of 15 minutes), and/or has taken insufficient total breaks for the amount of total working time completed in the shift (30 minutes if total working time is 9hrs or less or 45minutes if total working time exceeds 9hrs). Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules and that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "A common problem is where a driver has concentrated on taking sufficient breaks from driving under EU rules, but gone on to work for more than 6hrs without taking sufficient breaks. In this instance, the driver needs to be instructed in the correct rules. Also drivers can often misjudge the amount of break recorded and be just a few minutes short – particularly when using a digital tachograph which 'rounds up' driving and so can 'round down' breaks. Drivers should be advised that if in doubt they should take slightly too much break, rather than too little.",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate.",
        "extra": null
      }
    ]
  },
  {
    "id": 248,
    "code": "wnw1",
    "title": "Exceeded maximum night work",
    "law": [
      "The Road Transport (Working Time) Regulations 2005",
      "Regulation 9: '(1) The working time of a mobile worker who performs night work in any period of 24 hours, shall not exceed 10 hours during that period. (2) The period of 10 hours may be extended in relation to particular mobile workers or groups of mobile workers for objective or technical reasons concerning the organisation of work, by a collective agreement or a workforce agreement.... (4) An employer shall take all reasonable steps in keeping with the need to protect the health and safety of mobile workers, to ensure that the limit specified in paragraph (1), or extended in accordance with paragraph (2), is complied with in the case of each mobile worker employed by him.'",
      "Regulation 2: '... “night work” means any work performed during night time' and '. ... “night time” means in respect of goods vehicles the period between midnight and 4am and in respect of a passenger vehicles the period between 1am and 5am;'"
    ],
    "penalties": [
      {
        "id": 249,
        "fine": "",
        "description": [
          "Penalties range from the issue of an improvement notice (giving a period of time to put the problem right), a prohibition notice (prohibiting operations until the problem is rectified) to unlimited fines and up to two years in prison on indictment."
        ],
        "disclaimer": false
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code means the driver has worked during night time (midnight-4am for goods vehicle drivers, 1am-5am for passenger vehicle drivers) for more than 10hrs in any 24-hour period. The 24-hour period is a rolling period, rather than one that starts and ends at a fixed point – so the check rolls forward and backwards for 24hrs.",
        "extra": null
      },
      {
        "information": "If your organisation has a collective or workforce agreement to vary the night work limit, advise your TachoLogistics UK contact and we will not apply this code in future. Otherwise, investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules and that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this may also be a scheduling/management error. Audit systems to track working time compliance to prevent future breaches.",
        "extra": null
      }
    ]
  },
  {
    "id": 250,
    "code": "www1",
    "title": "Exceeded the maximum of 48 average working hours in the week",
    "law": [
      "The Road Transport (Working Time) Regulations 2005",
      "Regulation 4: '...(2) In any reference period which is applicable to his case, a mobile worker's working time shall not exceed an average of 48 hours for each week. ... (8) An employer shall take all reasonable steps, in keeping with the need to protect the health and safety of the mobile worker, to ensure that the limits specified above are complied with in the case of each mobile worker employed by him.' "
    ],
    "penalties": [
      {
        "id": 251,
        "fine": "",
        "description": [
          "Penalties range from the issue of an improvement notice (giving a period of time to put the problem right), a prohibition notice (prohibiting operations until the problem is rectified) to unlimited fines and up to two years in prison on indictment."
        ],
        "disclaimer": false
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code means the driver has exceeded 48hrs average over the reference period. ",
        "extra": null
      },
      {
        "information": "If your organisation has a collective or workforce agreement to vary the reference period, advise your TachoLogistics UK contact, as this may affect the calculations. However, note that drivers in scope of the Road Transport (Working Time) Regulations may not opt out of the 48hr average week.  Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules and that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is more likely to be a scheduling/management error. Audit systems to track working time compliance to prevent future breaches.",
        "extra": null
      }
    ]
  },
  {
    "id": 252,
    "code": "www2",
    "title": "Exceeded the maximum of 60 working hours in the week",
    "law": [
      "The Road Transport (Working Time) Regulations 2005",
      "Regulation 4: '(1) ... the working time, including overtime, of a mobile worker shall not exceed 60 hours in a week. ... (8) An employer shall take all reasonable steps, in keeping with the need to protect the health and safety of the mobile worker, to ensure that the limits specified above are complied with in the case of each mobile worker employed by him.'",
      "Regulation 2: '... “week” means any period of seven days beginning at midnight between Sunday and Monday.'"
    ],
    "penalties": [
      {
        "id": 253,
        "fine": "",
        "description": [
          "Penalties range from the issue of an improvement notice (giving a period of time to put the problem right), a prohibition notice (prohibiting operations until the problem is rectified) to unlimited fines and up to two years in prison on indictment."
        ],
        "disclaimer": false
      }
    ],
    "infringements": null,
    "advice": [
      {
        "information": "This code means the driver has exceeded 60hrs total working time in a fixed week. ",
        "extra": null
      },
      {
        "information": "Investigate reasons for infringement and take appropriate steps to ensure it does not happen again.",
        "extra": null
      },
      {
        "information": "Ensure schedules allow compliance with the rules and that payments or bonuses do not encourage breaches as well as the driver understands and complies with rules. ",
        "extra": null
      },
      {
        "information": "As this may be a driver error, you should also look to your organisation's policy on training and also disciplinary processes, as appropriate. However, this is more likely to be a scheduling/management error. Audit systems to track working time compliance to prevent future breaches.",
        "extra": null
      }
    ]
  }
]